import React from 'react';

import FlatButton from 'material-ui/FlatButton'
import LinkIcon from 'material-ui/svg-icons/content/link';
import UndoIcon from 'material-ui/svg-icons/content/undo';
import TrashIcon from 'material-ui/svg-icons/action/delete';
import OpenIcon from 'material-ui/svg-icons/action/open-in-new';
import ContentClearIcon from 'material-ui/svg-icons/content/clear';
import LocalOfferIcon from 'material-ui/svg-icons/maps/local-offer';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import TrashForeverIcon from 'material-ui/svg-icons/action/delete-forever';


const btnStyle = {
  position: 'absolute',
  top: 10,
  minWidth: 60,
  color: '#fff',
};


const iconBtnStyle = {
  position: 'absolute',
  top: 6,
  minWidth: 60,
  height: 42,
  lineHeight: '42px',
  color: '#fff',
};


const iconWrapperStyle = {
  lineHeight: '14px',
  fontSize: '14px',
}


const iconTextStyle = {
  lineHeight: '14px',
  fontSize: '14px',
}


const getIcon = (icon, style) => {
  switch(icon) {
    case 'open':
      return (<OpenIcon style={style} />);
    case 'trash':
      return (<TrashIcon style={style} />);
    case 'original':
      return (<LinkIcon style={style} />);
    case 'editTags':
      return (<LocalOfferIcon style={style} />);
    case 'restore':
      return (<UndoIcon style={style} />);
    case 'purge':
      return (<TrashForeverIcon style={style} />);
    default:
      return (<OpenIcon style={style} />);
  }
}


export default class MainAppBarSelected extends React.Component {

  click(actionName, payload=null) {
    payload = payload || {};
    const { onAction } = this.props;
    onAction && onAction({...payload, name: 'click', target: actionName});
  }

  render() {
    const { actions, selected } = this.props;
    console.log('selected', selected);
    return (
      <div>
        <FlatButton
          icon={<ContentClearIcon />}
          labelPosition="after"
          label="CLEAR"
          backgroundColor="#FF3368"
          hoverColor="#FF3368"
          style={{...btnStyle, left: 10}}
          onTouchTap={e => {this.click('main-app-bar-selected-clear');}}
        />
        <FlatButton
          title={'You have selected ' + selected.length + ' molecules'}
          label={selected.length + ' molecules selected'}
          style={{...btnStyle, left: 120}}
          onTouchTap={e => {this.click('main-app-bar-selected-count');}}
        />
        {actions.map((action, index) => {
          const position = 62 * (index + 1) + 2;
          return (
            <FlatButton
              key={action.name}
              style={{...iconBtnStyle, right: position}}
              title={action.description}
              onTouchTap={e => {this.click(
                'main-app-bar-selected-action', {actionName: action.name}
              );}}
            >
              <div style={iconWrapperStyle}>
                {getIcon(action.icon, {color: '#fff'})}
              </div>
              <div style={iconTextStyle}>{action.label}</div>
            </FlatButton>
          );
        })}
        <FlatButton
          icon={<MoreVertIcon style={{color: '#fff'}} />}
          style={{...iconBtnStyle, right: 2}}
          onTouchTap={e => {this.click('main-app-bar-selected-more');}}
        />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MainAppBar/MainAppBarSelected.jsx